import { Control, useController, FieldPath } from 'react-hook-form';
import { AceGenericFieldLayout } from './AceGenericFieldLayout';
import { ReactNode } from 'react';
import { InputGroup } from '@blueprintjs/core';
import { defaultFormatter } from './common';

export interface AceTextFieldProps<T extends object, V> {
  control: Control<T>;
  name: FieldPath<T>;
  formatter?: (value: V) => ReactNode;
  editable?: boolean;
  label?: ReactNode;
  placeholder?: string;
  warning?: ReactNode;
  vertical?: boolean;
}

export function AceTextField<T extends object, V>({
  control,
  name,
  editable,
  label,
  formatter = defaultFormatter,
  placeholder,
  warning,
  vertical,
}: AceTextFieldProps<T, V>) {
  const { field, fieldState } = useController({ control, name });

  const formattedValue = formatter(field.value);

  return (
    <div>
      <AceGenericFieldLayout
        editable={editable}
        label={label}
        error={fieldState.error?.message}
        warning={warning}
        vertical={vertical}
        valueElement={formattedValue}
        inputElement={
          <InputGroup
            type="text"
            name={field.name}
            onChange={field.onChange}
            onBlur={field.onBlur}
            value={field.value ?? ''}
            inputRef={field.ref}
            placeholder={placeholder}
            fill
          />
        }
      />
    </div>
  );
}
